import animejs from 'animejs';
import { throttle } from "../helpers/utils";
import {START_PLAY_VIDEO_EVENT, STOP_PLAY_VIDEO_EVENT} from "../constants/events";
export default class Header {
    constructor() {
        this.$root = document.querySelector('.site-header-wrapper');
        this.$mobileHeader = document.querySelector('.site-header-mobile');
        this.$videoControl = document.querySelector('.site-header-nav-item.-video-control');
        this.$stopPlayVideo = document.getElementById('headerStopPlayVideo');

        this.init();
    }

    init() {
        window.addEventListener('scroll', throttle(() => {
            const mediaMatches = window.matchMedia('(max-width: 768px)').matches;

            if (window.scrollY >= (mediaMatches ? 10 : 30)) {
                this.$root.classList.add('-pinned');
            } else {
                this.$root.classList.remove('-pinned');
            }
        }, 20));
        // PROMO
        // if (EnvHelper.page.handle === 'course-entry') {
        //     window.addEventListener('scroll', throttle(() => {
        //         const mediaTablet = window.matchMedia('(max-width: 768px) and (min-width: 671px').matches;
        //         const mediaMatches = window.matchMedia('(max-width: 670px)').matches;
        //
        //         if (window.scrollY >= (mediaMatches ? 90 : mediaTablet ? 40 : 0)) {
        //             this.$root.classList.add('-pinned');
        //         } else {
        //             this.$root.classList.remove('-pinned');
        //         }
        //     }, 20));
        // } else {
        //     window.addEventListener('scroll', throttle(() => {
        //         const mediaMatches = window.matchMedia('(max-width: 768px)').matches;
        //
        //         if (window.scrollY >= (mediaMatches ? 10 : 30)) {
        //             this.$root.classList.add('-pinned');
        //         } else {
        //             this.$root.classList.remove('-pinned');
        //         }
        //     }, 20));
        // }

        window.addEventListener(START_PLAY_VIDEO_EVENT, () => {
            this.$mobileHeader.classList.add('-playing');
            animejs({
                targets: this.$videoControl,
                opacity: [0, 1],
                duration: 200,
                easing: 'easeInOutCubic'
            });
        });

        window.addEventListener(STOP_PLAY_VIDEO_EVENT, () => {
            animejs({
                targets: this.$videoControl,
                opacity: 0,
                duration: 200,
                easing: 'easeInOutCubic',
                complete: (anim) => {
                    if (anim.completed) {
                        this.$mobileHeader.classList.remove('-playing');
                    }
                }
            });
        });

        this.$stopPlayVideo.addEventListener('click', () => {
            window.dispatchEvent(new CustomEvent(STOP_PLAY_VIDEO_EVENT));
        });
    }
}